import {h, Fragment} from "preact"
import { popularSearchTerms, isFrench } from '../config'
import { useAppState, HistoryElement } from '@nosto/preact'
import { useEffect, useRef } from 'preact/hooks'

export default () => {
    const autocomRef = useRef(null);
    const backdropRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {  
            let position = '';       
            if (window.innerWidth <= 1023 && window.scrollY > 0) {
                window.scrollY < 35
                    ?   position = (64 + (35 - window.scrollY)) + 'px'
                    :   position = '64px'
            } else if (window.innerWidth >= 1024 && window.scrollY > 0) {
                window.scrollY < 45
                    ?   position = (75 + (45 - window.scrollY)) + 'px'
                    :   position = '75px'
            }
            if(autocomRef.current) {
                autocomRef.current.style.top = position;
            }
            if(backdropRef.current) {
                backdropRef.current.style.top = position;
            }
        }
        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    useEffect(() => {
        window.nostojs(api => {
            api.createRecommendationRequest({ includeTagging: false })
            .setElements(['searchautocomplete-nosto-1'])
            .loadRecommendations({ skipPageViews: true, skipEvents: true })
        })
    }, [])

    const closeAutocomplete = () => {
        document.querySelector('section[data-section="header"]').click();
    }

    return (
        <>
            <div class="ns-autocomplete fixed" ref={autocomRef}>
                <div class="ns-ac-content flex"> 
                    <div class="ns-popularsearches-wrapper">
                        <div class="ns-popularsearches-title">{isFrench ? 'Recherches Populaires' : 'Popular Searches'}</div>
                        <div class="ns-popularsearches-container flex flex-row">
                            {popularSearchTerms.en.length > 0 && popularSearchTerms.fr.length > 0 && (
                                isFrench
                                    ? popularSearchTerms.fr.map((term) => (
                                        <HistoryElement query={{ query: term }}>
                                            <button className="ns-popular-search" type="button">{term}</button>
                                        </HistoryElement>
                                    ))
                                    : popularSearchTerms.en.map((term) => (
                                        <HistoryElement query={{ query: term }}>
                                            <button className="ns-popular-search" type="button">{term}</button>
                                        </HistoryElement>
                                    ))
                            )}
                        </div>
                    </div>
                    <div class="nosto_element w-full" id="searchautocomplete-nosto-1"></div>
                </div>
            </div>
            <div class="ns-autocomplete-backdrop fixed" onClick={closeAutocomplete} ref={backdropRef} />
        </>
    )
}
